import { QueryClientProvider } from '@tanstack/react-query';
import { type FC, type ReactNode } from 'react';

import { QueryStateAppContextProvider } from '@/packages/query-state/shared/context/appContext';
import { type IQueryState } from '@/packages/query-state/shared/services/QueryState';
import { type IQueryStateAppContext } from '@/packages/query-state/shared/types/appContext';

import { ReactQueryDevtools } from './internal/components/ReactQueryDevtools';

type TQueryStateProviderProps = {
  appContext: IQueryStateAppContext;
  queryState: IQueryState;
  children: ReactNode;
  devTools?: boolean;
};

export const QueryStateProvider: FC<TQueryStateProviderProps> = props => {
  const {
    appContext,
    queryState: { queryClient },
    // devTools,
    children,
  } = props;

  return (
    <QueryStateAppContextProvider value={appContext}>
      <QueryClientProvider client={queryClient}>
        {appContext.custom.isTestMode && <ReactQueryDevtools />}
        {children}
      </QueryClientProvider>
    </QueryStateAppContextProvider>
  );
};
